/**
 * Spacing Constants - Centralized spacing system for Green Filter
 * Uses 8px base scale for consistency
 */

export const SPACING = {
  // Base scale (8px system)
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',

  // Section spacing
  sectionSmall: '48px',
  section: '60px',
  sectionLarge: '80px',

  // Hero/Header
  headerGap: '110px',      // Mobile header gap
  heroDesktop: '150px',    // Standard hero top padding
  heroMobile: '130px',
} as const;

export type SpacingName = keyof typeof SPACING;
